import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AutoComplete, Input, Drawer, Tag, Select, Form } from "antd";
import "./LocationFilter.css";
import FilterLocation from "./location.filter";
import { fetchKeySearchDynamicLocation } from "../../../../redux/actions";
import { indexOf } from "lodash";

const Location = ({
  emptyCityInput,
  setEmptyCityInput,
  setCheck,
  check,
  setCheckCityId,
  checkCityId,
  setCheckLocationRegion,
  checkLocationRegion,
  setlocObj,
  searchLocationFilter,
  country,
  region,
  fromCandMkt,
  locObj,
}) => {
  const dispatch = useDispatch();
    const { Option } = Select;
  // const [locationValue, setLocationValue] = useState([]);
  const [visible, setVisible] = useState(false);

  const stateSuggestions = useSelector(
    (state) => state.searchSkillListingReducer.stateSuggestions
  );
  const regionSuggestions = useSelector(
    (state) => state.searchSkillListingReducer.regionSuggestions
  );
  const locations = useSelector(
    (state) => state.searchSkillListingReducer.locations
  );
  // const filters = useSelector(state => state.searchSkillListingReducer.filters);
 
  const [selectedItems, setSelectedItems] = useState([]);
  const [valueCheck,setValueCheck] = useState(check.map(item => item.name))
  const [valueCheckId,setValueCheckId] = useState(check.map(item => item.ids))
  const [isSelectVisible, setIsSelectVisible] = useState(false);
useEffect(()=>{
  setValueCheck(check.map(item => item.name))
  setValueCheckId(check.map(item => item.ids))
},[check])

  const showDrawer = () => {
    setVisible(true);
    setIsSelectVisible(false);
  };

  const onClose = () => {
    setVisible(false);
    setIsSelectVisible(false);
  };

  const handleCityChange = (flag) => { 
    if(flag){
      if(emptyCityInput === ''){
        setEmptyCityInput() 
      }
    }
    if (!flag) {
      setEmptyCityInput("");
    }
    setVisible(flag);
  };

  // const valueCheck = check.map((item) => item.name).join(", ");
  const valueID = check.map((item) => item.ids);

  useEffect(() => {
    if (
      check.length === 0 &&
      !visible &&
      region.length === 0 &&
      country.length === 0
    ) {
      const params = {
        body: searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params))
    } else if(locations.length == 0 && check.length > 0){
      searchLocationFilter.obj['CityId'] = valueCheckId
      const params = {
        body: searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params));
    }
  },[visible])
 
  
  const handleDeselect=(deselectedValue)=>{
    const updatedValues = check.filter((value) => value.name!== deselectedValue);
    setCheck(updatedValues);
    setValueCheck(updatedValues)

    //for ids and checked values 
    const deselectedIndex =  check.findIndex(value => value.name == deselectedValue)
    setCheckCityId(checkCityId.filter(((val,index) => index!== deselectedIndex))) 
  }
  

  return (
    <div className="search-location-filter-mobile">
      <Drawer
        className="location-drawer"
        onClose={onClose}
        visible={visible}
        closable={true}
        placement={"top"}
        title={"Select city/cities"}
        afterOpenChange={(e) => {
          handleCityChange(e);
        }}
      >
        <FilterLocation
          setlocObj={setlocObj}
          locObj={locObj}
          setcheck={setCheck}
          check={check}
          setCheckCityId={setCheckCityId}
          checkCityId={checkCityId}
          // setCheckLocationRegion={setCheckLocationRegion}
          // checkLocationRegion={checkLocationRegion}
          emptyCityInput={emptyCityInput}
          mobileFilter={true}
          setVisible={setVisible}
          searchLocationFilter={searchLocationFilter}
          setEmptyCityInput={setEmptyCityInput}
          fromCandMkt = {fromCandMkt ?? false}
        />
      </Drawer>
 {/* <div > */}
 {/* <Select
        style={{width:'100%'}}
        mode="tags"
        className="input"
        value={valueCheck}
        onClick={showDrawer}
        closable
        bordered={false}
        // type={'input'}
         placeholder="Search city" 
         onClose={console.log("closec close")}
         
         /> */}
        
            
            <Form>
      <Form.Item>
        <Select
         value={valueCheck}
          placeholder="Search city"
          className="input"
          mode="multiple"
          bordered={false}
          onDeselect={handleDeselect}
          onClick={showDrawer}
          showSearch
          listHeight={160}
          open={isSelectVisible}
        >
        </Select>
      </Form.Item>
    </Form>


    </div>
  );
};
export default Location;
